import React from "react";
import "./SocialAwarenessPage.css";
import Banner from "../Component/social awareness.jpg"; // 🖼️ Replace with your actual banner image path

const SocialAwarenessPage = () => {
  return (
    <div className="awareness-page">
      {/* ✅ Banner Section */}
      <div className="awareness-banner">
        <img src={Banner} alt="Social Awareness Program" className="banner-img" />
      </div>

      {/* ✅ Content Section */}
      <div className="awareness-content">
        <h2>Social Awareness Programs at CPIT</h2>
        <p>
          The <strong>Career Point of Information Technology (CPIT)</strong> strongly believes that
          education should go hand in hand with social responsibility. The institute regularly organizes
          <strong> Social Awareness Programs</strong> to inspire students and citizens to contribute
          toward building a better society through knowledge, empathy, and action.
        </p>

        <h2>Objective of the Awareness Programs</h2>
        <p>
          The main objective of these programs is to raise awareness on key social, environmental, and
          health-related issues. CPIT aims to create responsible citizens who understand the value of
          sustainability, equality, and human welfare. These initiatives help students develop leadership,
          communication, and problem-solving skills while serving society.
        </p>

        <h2>Major Awareness Campaigns Organized</h2>
        <ul>
          <li>🌱 <strong>Environmental Awareness</strong> — Campaigns promoting tree plantation, waste management, and clean surroundings.</li>
          <li>🚭 <strong>Anti-Tobacco & Anti-Drug Drives</strong> — Sessions on the harmful effects of addiction and lifestyle awareness.</li>
          <li>🩺 <strong>Health & Hygiene Awareness</strong> — Workshops on fitness, menstrual hygiene, and preventive health care.</li>
          <li>💻 <strong>Digital Safety Awareness</strong> — Seminars on cyber safety, responsible internet use, and online fraud prevention.</li>
          <li>📚 <strong>Education for All</strong> — Volunteer activities to spread the importance of education in underprivileged communities.</li>
          <li>👩‍🦽 <strong>Inclusivity Awareness</strong> — Programs promoting equality, women empowerment, and rights for differently-abled people.</li>
        </ul>

        <h2>Impact of the Programs</h2>
        <p>
          These initiatives have helped hundreds of students and local citizens to understand and act upon
          critical social issues. CPIT’s active participation has strengthened its image as an institution
          that not only imparts technical knowledge but also shapes socially conscious individuals.
        </p>

        <h2>Student Involvement</h2>
        <p>
          Students from various departments actively participate in these programs by preparing informative
          presentations, street plays, posters, and awareness rallies. Their creativity and passion have
          played a major role in spreading awareness across the community.
        </p>

        <h2>Future Goals</h2>
        <p>
          CPIT plans to expand its social awareness initiatives by introducing <strong>mental health workshops,
          digital literacy sessions, traffic safety campaigns,</strong> and collaborations with NGOs to ensure
          lasting social impact.
        </p>

        <h2>Conclusion</h2>
        <p>
          The <strong>Social Awareness Programs</strong> organized by CPIT are a reflection of the institute’s
          dedication toward nation-building through education and community service. With every initiative,
          CPIT moves one step closer to creating a more informed, responsible, and compassionate generation.
        </p>
      </div>
    </div>
  );
};

export default SocialAwarenessPage;
